import React, { useState } from 'react';
import classnames from 'classnames';
import { Link, useLocation } from 'react-router-dom';

import Anchor from '../../common/svg/Anchor';

import { CrossIcon, MenuIcon } from '../../common/Icon';
import { forecastNavigationLinks, forecastDropdownLinks } from '../../../constants/navigation';
import styles from './styles';

import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';

import { public_urls } from '../../../config';
import { getLinkProps } from '../../../utils';
import { ClickAwayListener } from '@material-ui/core';

const useStyles = makeStyles(styles);

function PersistentDrawerLeft({ user }) {
  const location = useLocation();
  const currentPage = location.pathname;
  const isHomePage = currentPage === public_urls.home;

  const classesDrawer = useStyles();
  const [open, setOpen] = useState(false);
  const [openSascNav, setOpenSascNav] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setOpenSascNav(false);
  };

  const getForecastLinks = () =>
    forecastNavigationLinks.filter(({ roles = [] }) =>
      roles.length > 0 && user ? user.userTeams.some(value => roles.includes(value)) : true,
    );

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div className={classesDrawer.root} data-testid="header-persistent-drawer-left">
        <Toolbar className={classesDrawer.toolBar}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setOpen(!open)}
            edge="start"
            className={classnames(classesDrawer.menuButton, open && classesDrawer.hide)}
          >
            {open ? (
              <CrossIcon fontSize="inherit" title="close menu" />
            ) : (
              <MenuIcon viewBox="0 0 20 20" title="open menu" />
            )}
          </IconButton>
        </Toolbar>
        <Drawer
          className={classesDrawer.drawer}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{
            paper: classesDrawer.drawerPaper,
          }}
        >
          {!isHomePage && (
            <>
              <List className={classesDrawer.list}>
                {getForecastLinks().map(({ link, title }) => (
                  <ListItem
                    className={classnames(classesDrawer.listItem, {
                      [classesDrawer.active]: currentPage === link,
                    })}
                    to={link}
                    component={Link}
                    button
                    key={title}
                    onClick={handleClose}
                  >
                    <ListItemText className={classesDrawer.listItemText} primary={title} />
                  </ListItem>
                ))}
              </List>
              <Divider variant="middle" />
            </>
          )}
          <ListItem
            className={classnames(classesDrawer.listItem, classesDrawer.deleteBorder, classesDrawer.otherTools)}
            button
            onClick={() => setOpenSascNav(!openSascNav)}
          >
            <ListItemText className={classesDrawer.listItemText} primary={forecastDropdownLinks.title} />
            {openSascNav ? <Anchor anchor="up" /> : <Anchor anchor="down" />}
          </ListItem>
          <Collapse in={openSascNav} timeout="auto" unmountOnExit>
            <List className={classesDrawer.dropdown} component="div" aria-label="collapse-sasc-tools">
              {forecastDropdownLinks.links.map(link => {
                return (
                  <ListItem
                    key={link.link}
                    button
                    className={classnames(classesDrawer.listItem, classesDrawer.deleteBorder)}
                    {...getLinkProps(link)}
                    onClick={handleClose}
                  >
                    <ListItemText
                      className={classnames(classesDrawer.listItemText, classesDrawer.tool)}
                      primary={link.title}
                    />
                  </ListItem>
                );
              })}
            </List>
          </Collapse>
        </Drawer>
      </div>
    </ClickAwayListener>
  );
}

export default PersistentDrawerLeft;
